export default "__VITE_ASSET__78ff5e0d__"